import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";
import { IconType } from "~/common/components/icon/IconType";
import { REGISTER_PAGE } from "~/utils/url/staticUrls";

import classes from "~/features/configurator/Linear/components/LinearTeaser.module.less";
import classNames from "classnames";
import { Box, Button, styled } from "~/common/mui";
import { Icon } from "~/common/components/icon/Icon";
import { IconSize } from "~/common/components/icon/IconSize";
import { useTranslation } from "react-i18next";

const StyledTeaser = styled(Box)(({ theme }) => ({
  // gridArea: "teaser", // Removed positioning
}));

export const LinearTeaser = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <StyledTeaser className={classNames(classes.root, className)}>
      <MediasLogo variant={"plus"} className={classes.logo} />
      <div className={classes.divider} />
      <div className={classes.text}>{t("page.linear.summary.register.message")}</div>
      <Button
        className={"scha__lc-summary__lc-register-teaser-button"}
        href={REGISTER_PAGE}
        startIcon={<Icon type={IconType.User} size={IconSize.FONT_20} />}
      >
        {t("page.registerFree.register")}
      </Button>
    </StyledTeaser>
  );
};
